import { computed, makeObservable } from 'mobx'

import BasicAuthStore from 'Core/stores/basicAuthStore/BasicAuthStore'

import { Permission, UserRole } from 'Portals/Customer/constants'
import { RootStore } from 'Portals/Customer/stores'

export class AuthStore extends BasicAuthStore<UserRole, Permission> {
	constructor(private rootStore: RootStore) {
		super()
	}

	@computed
	get isImpersonatorPMView(): boolean {
		return this.impersonatorViewPermission === Permission.PM_VIEW
	}
}
